import React, { FC } from 'react';

import styled from 'styled-components';

import LoadingSpinner from '../nav/LoadingSpinner';

const AampeOverlay: FC<React.PropsWithChildren<unknown>> = () => (
    <Overlay>
        <StyledLoadingSpinner />
    </Overlay>
);

const Overlay = styled.div({
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: `rgba(0, 0, 0, 0.5)`,
    zIndex: 999,
});

const StyledLoadingSpinner = styled(LoadingSpinner)({
    height: '100%',
});
export default AampeOverlay;
